import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import { getToken } from './utils/auth'
import "./assets/css/bootstrap.min.css"
import "./assets/css/bootstrap-datetimepicker.min.css"
import "./assets/css/iconfont.css";
import "./assets/css/font-awesome.min.css";
import "./assets/css/themify-icons.css";
import "./assets/css/main.css";
import '@babel/polyfill';
import uploader from 'vue-cqkd-upload';
import "./assets/js/bootstrap.min.js";
import "./assets/js/iconfont.js";
import "./assets/js/bootstrap-datetimepicker.min.js";
import "./assets/js/bootstrap-datetimepicker.zh-CN.js";
// import "./assets/js/main.js";
import "./assets/js/bootstrap-treeview.min.js";
import VueClipboard from 'vue-clipboard2'
// import zh_CN from 'vee-validate/dist/locale/zh_CN';
import zh_CN from './utils/zh_CN';
import VeeValidate, { Validator } from 'vee-validate';
import Message from '@/components/message/index.js';
import Confirm from '@/components/message-box/index.js';
import preview from '@/plugins/preview.js';
import { whiteList, config } from '@/config/index.js';
Vue.use(preview);
Vue.use(VueClipboard)
Vue.prototype.$message = Message;
Vue.prototype.$confirm = Confirm;
Vue.use(VeeValidate);
Validator.localize('zh_CN', zh_CN);
Validator.extend('email_prefix', {
  getMessage: field => field + '不是一个有效的邮箱',
  validate: value => {
    return /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value + '@ustc.edu.cn')
  }
});
Vue.use(uploader)
Vue.directive('focus', {
  update: function (el, { value }) {
    if (value) {
      el.focus();
    }
  }
})
router.beforeEach((to, from, next) => {
  if (getToken()) {
    if (to.name === 'login' || to.name === 'index') {
      next({ name: 'persona' })  // 如果已经登录了跳转到个人中心
    } else {
      if (store.state.user.authenticated) {
        next()
      } else {
        store.dispatch('UserInfo').then(() => {
          next({ ...to })
        })
      }
    }
  } else {
    if (whiteList.indexOf(to.name) > -1) {
      next()
    } else {
      // next({ name: 'login' })
      const routeUrl = router.resolve({
        name: "login_terminal"
      });
      window.location.href = `${config.loginUrl}` + encodeURIComponent(`${window.location.origin}${routeUrl.href}`);
    }
  }
})
// router.beforeEach((to, from, next) => {
//   if (to.meta.requireAuth) {
//     if (store.state.user.authenticated || getToken()) {
//       return next()
//     } else {
//       return next({ name: 'login' })
//     }
//   }

//   if (to.meta.requireGuest) {
//     if (store.state.user.authenticated || getToken()) {
//       return next({ name: 'persona' })
//     } else {
//       return next()
//     }
//   }
//   return next()
// });
Vue.config.devtools = true;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
